import { useCallback } from "react";
import { SidePanelDS, Spacer } from "@qivia/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { isThisMonth } from "date-fns";
import { useAppSelector } from "../../../../../redux/hooks";
import {
  selectHomeChargingSupportingDocuments,
  selectHomeChargingSupportingDocumentsPeriod,
} from "../../homeChargingSupportingDocumentsSlice";
import { getHomeChargingSupportingDocumentStatus } from "../../lib";
import { SidePanelHeader } from "./sidePanelHeader";
import { SidePanelSectionBlock } from "./sectionBlock";
import { SupportingDocumentDetails } from "./supportingDocumentDetails";
import "../../../../../i18n/i18n";

export const SupportingDocumentSidePanel = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const firstPath = location.pathname.split("/")[1];
  const supportingDocuments = useAppSelector(
    selectHomeChargingSupportingDocuments,
  );
  const supportingDocumentsPeriod = useAppSelector(
    selectHomeChargingSupportingDocumentsPeriod,
  );

  const supportingDocument =
    supportingDocuments.find(
      (supportingDocument) => supportingDocument.driverUuid === params.id,
    ) ?? null;

  const onSidePanelClosed = useCallback(() => {
    navigate(`/${firstPath}/electric_charging/supporting_documents`);
  }, [firstPath, navigate]);

  if (!supportingDocument || !supportingDocumentsPeriod) {
    return;
  }

  const status = getHomeChargingSupportingDocumentStatus(
    supportingDocument,
    isThisMonth(new Date(supportingDocumentsPeriod.from)),
  );

  return (
    <SidePanelDS.SidePanel
      visible={!!supportingDocument}
      onClose={onSidePanelClosed}
    >
      <SidePanelDS.Section
        verticalSpacing={1.2}
        horizontalSpacing={1.5}
        background={colors["colors/button/secondary/hover"]}
      >
        <SidePanelHeader
          supportingDocument={supportingDocument}
          status={status}
          period={supportingDocumentsPeriod}
        />
        <Spacer y={1} />
        <SidePanelSectionBlock
          supportingDocument={supportingDocument}
          firstPath={firstPath}
        />
      </SidePanelDS.Section>
      <SidePanelDS.Section verticalSpacing={1.5} horizontalSpacing={1.5}>
        <SupportingDocumentDetails supportingDocument={supportingDocument} />
      </SidePanelDS.Section>
    </SidePanelDS.SidePanel>
  );
};
